import React, { useEffect, useState } from "react";
import PlantillaScreen from '../../../helpers/PlantillaScreen'
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../../Finanzas/Helper/GetMonthNameByNumber";
import Settings from "@mui/icons-material/Settings";
import AgregarContactoModal from "./AgregarContactoModal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import FiltroPostventaCotizaciones from "../Cotizaciones/FiltroPostventaCotizaciones";
import { BuscadorModelosExcluidosMantenimiento } from "./BuscadorModelosExcluidosMantenimiento";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { ExcluirModelosModal, ModelosExcluidosMantenimientoModal } from "./ModelosExcluidosMantenimientoModal";
import CambiarSucursalModal from "./CambiarSucursalModal";
import EditIcon from '@mui/icons-material/Edit';
import CommentIcon from '@mui/icons-material/Comment';
import { ModalComentariosTimeline } from "../Cotizaciones/ModalComentariosTimeline";
import FiltroMultiple from "../Modales/FiltroMultiple";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { ChatScreen } from "../../../Whatsapp/ChatScreen";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { esTelefonoValido } from "../Helpers/esTelefonoValido";

export const MantenimientoMainScreen = () => {
    const history = useHistory();
    const [boxstate, setBoxState] = useBox();
    const location = useLocation();
    const [serviciosPendientes, setServiciosPendientes] = useState();
    const [titulo, setTitulo] = useState('SERVICIOS PENDIENTES');
    const [registroSelect, setRegistroSelect] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [openModalSucursal, setOpenModalSucursal] = useState(false);
    const [openModalExcluir, setOpenModalExcluir] = useState(false);

    const [folioSelect, setFolioSelect] = useState();
    const [openModalComentarios, setOpenModalComentarios] = useState(false);
    const [folioSelected, setFolioSelected] = useState("");
    const [fechaRecordatorio, setFechaRecordatorio] = useState("");

    const [modalChat, setModalChat] = useState(false);
    const [telefonoContacto, setTelefonoContacto] = useState("");
    const [cliente, setCliente] = useState("");

    const meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    //Totales
    const [totalCotizacion, setTotalCotizacion] = useState(0);

    // filtros en tabla
    const [options, setOptions] = useState({
        estatus: [],
        mensajes: [],
        facturado: [],
        contacto: []
    });

    const [filtros, setFiltros] = useState({
        estatus: [],
        mensajes: [],
        facturado: [],
        contacto: []
    });

    const [filtrosTemp, setFiltrosTemp] = useState({
        estatus: [],
        mensajes: [],
        facturado: [],
        contacto: []
    });

    const [prioridadFiltros, setPrioridadFiltros] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);

    const [mostrarFiltro, setMostrarFiltro] = useState({
        contacto: { open: false },
        estatus: { open: false },
        mensajes: { open: false },
        facturado: { open: false }
    });

    const handleOpenModalChat = (numero, cliente) => {
        setTelefonoContacto(numero);
        setCliente(cliente);
        setModalChat(true);
    };
    // console.log(cliente, telefonoContacto, modalChat)

    const handleCloseModalChat = () => {
        setTelefonoContacto("");
        setCliente("");
        setModalChat(false);
    };

    const {
        sucursales,
        adr,
        ejercicio_inicio,
        ejercicio_fin,
        periodo_inicio,
        periodo_fin,
        estatus,
        motivo,
        filtroSucursales
    } = location.state || {};

    // console.log(boxstate)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros(prev => {
            const index = prev.indexOf(filtro);

            // si no existe → agregar
            if (index === -1) {
                return [...prev, filtro];
            }

            // si existe → cortar todo después
            return prev.slice(0, index + 1);
        });
    };


    const aplicarFiltros = (data, filtros, filtrosPermitidos = []) => {
        let resultado = [...data];

        filtrosPermitidos.forEach(filtro => {
            if (filtro === "estatus" && filtros.estatus.length > 0) {
                resultado = resultado.filter(i =>
                    filtros.estatus.includes(i.estado)
                );
            }

            if (filtro === "mensajes" && filtros.mensajes.length > 0) {
                resultado = resultado.filter(i =>
                    filtros.mensajes.includes(i.mensajes_enviados)
                );
            }

            if (filtro === "facturado" && filtros.facturado.length > 0) {
                resultado = resultado.filter(i =>
                    filtros.facturado.includes(i.facturado)
                );
            }

            if (filtro === "contacto" && filtros.contacto.length > 0) {
                resultado = resultado.filter(i =>
                    filtros.contacto.includes(
                        i.contacto !== "N" ? "S" : "N"
                    )
                );
            }
        });

        return resultado;
    };

    //Actualizacion de datos dependiendo filtros
    useEffect(() => {
        if (!Array.isArray(serviciosPendientes)) return;

        let data = [...serviciosPendientes];

        prioridadFiltros.forEach(filtro => {
            switch (filtro) {
                case "estatus":
                    if (filtros.estatus.length > 0) {
                        data = data.filter(i => filtros.estatus.includes(i.estado));
                    }
                    break;

                case "mensajes":
                    if (filtros.mensajes.length > 0) {
                        data = data.filter(i => filtros.mensajes.includes(i.mensajes_enviados));
                    }
                    break;

                case "facturado":
                    if (filtros.facturado.length > 0) {
                        data = data.filter(i => filtros.facturado.includes(i.facturado));
                    }
                    break;

                case "contacto":
                    if (filtros.contacto.length > 0) {
                        data = data.filter(i =>
                            filtros.contacto.includes(i.contacto !== "N" ? "S" : "N")
                        );
                    }
                    break;

                default:
                    break;
            }
        });

        setDatosFiltrados(data);

        const totalCotizaciones = data.reduce(
            (acc, cotizaciones) => acc + (parseFloat(cotizaciones.total) || 0),
            0
        );
        setTotalCotizacion(totalCotizaciones);

    }, [serviciosPendientes, filtros, prioridadFiltros]);


    //Esquema de filtrado en tabla
    useEffect(() => {
        if (!Array.isArray(serviciosPendientes)) return;

        const getBaseData = (filtro) => {
            const index = prioridadFiltros.indexOf(filtro);

            if (index === -1) {
                return aplicarFiltros(serviciosPendientes, filtros, prioridadFiltros);
            }

            if (index === 0) return serviciosPendientes;

            return aplicarFiltros(
                serviciosPendientes,
                filtros,
                prioridadFiltros.slice(0, index)
            );
        };

        // ESTATUS
        const estatusOptions = [
            ...new Set(getBaseData("estatus").map(i => i.estado))
        ].map(v => ({
            value: v,
            label:
                v === "PE" ? 'Pendiente de envio' :
                    v === "EN" ? 'Mensaje enviado' :
                        v === "EG" ? 'Mensaje entregado' :
                            v === "LE" ? 'Mensaje leído' :
                                v === "CI" ? 'Cliente con interes' :
                                    v === "SI" ? 'Cliente sin interes' :
                                        v === "EE" ? 'Error en el envio' :
                                            v === "ET" ? 'Error en numero de telefono' :
                                                v === "RL" ? 'Respuesta escrita' :
                                                    "Desconocido"
        }));

        // MENSAJES
        const mensajesOptions = [...new Set(
            getBaseData("mensajes").map(i => i.mensajes_enviados)
        )].map(v => ({
            value: v,
            label:
                v === 0 ? "Pendiente" :
                    v === 1 ? "Recordatorio 1" :
                        v === 2 ? "Recordatorio 2" :
                            v === 3 ? "Recordatorio 3" :
                                "Desconocido"
        }));

        // FACTURADO
        const facturadoOptions = [...new Set(
            getBaseData("facturado").map(i => i.facturado)
        )].map(v => ({
            value: v,
            label: v === "S" ? "Si" : "No"
        }));

        // Contacto
        const contactoBase = getBaseData("contacto");

        const tieneContacto = contactoBase.some(i => i.contacto !== "N");
        const sinContacto = contactoBase.some(i => i.contacto === "N");

        const contactoOptions = [
            ...(tieneContacto ? [{ value: "S", label: "Sí" }] : []),
            ...(sinContacto ? [{ value: "N", label: "No" }] : [])
        ];

        setOptions({
            estatus: estatusOptions,
            mensajes: mensajesOptions,
            facturado: facturadoOptions,
            contacto: contactoOptions
        });

    }, [serviciosPendientes, filtros, prioridadFiltros]);

    const limpiarFiltros = () => {
        setFiltros({
            estatus: [],
            mensajes: [],
            facturado: [],
            contacto: [],
        });

        setFiltrosTemp({
            estatus: [],
            mensajes: [],
            facturado: [],
            contacto: [],
        });

        setPrioridadFiltros([]);
        setDatosFiltrados([]);
    };



    const handleOpenModalExcluir = () => {
        setOpenModalExcluir(true);
    };

    const handleCloseModalExcluir = () => {
        setOpenModalExcluir(false);
    };

    useEffect(() => {

        setBoxState("pv", {
            adr: filtroSucursales.adr,
            sucursal: filtroSucursales.sucursal,
            departamento: filtroSucursales.departamento,
        });

        // setBoxState("estatus", estatus);
        // setBoxState("motivo", motivo);
        if (openModal || openModalSucursal) return;
        onIniciar(
            ejercicio_inicio,
            ejercicio_fin,
            periodo_inicio,
            periodo_fin,
            estatus,
            motivo,
            sucursales,
            adr,
        );
    }, [openModal, openModalSucursal]);


    const onUpdate = () => {

        onIniciar(
            ejercicio_inicio,
            ejercicio_fin,
            periodo_inicio,
            periodo_fin,
            estatus,
            motivo,
            sucursales,
            adr
        );
    }

    const handleOpenModal = (idRegistro) => {
        setRegistroSelect(idRegistro);
        // console.log(idRegistro)
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setRegistroSelect(0);
        setOpenModal(false);
    };

    const handleOpenModalSucursal = (idRegistro) => {
        setRegistroSelect(idRegistro);
        // console.log(idRegistro)
        setOpenModalSucursal(true);
    };

    const handleCloseModalSucursal = () => {
        setRegistroSelect(0);
        setOpenModalSucursal(false);
    };



    const onConfiguracionPaquetes = () => {
        history.push("/PostVenta/ConfiguracionPaquetesMantenimiento");
    };

    // useEffect(() => {
    //     const fecha = new Date();
    //     const anioActual = fecha.getFullYear();
    //     const mesActual = fecha.getMonth() + 1;
    //     onExecute(anioActual, mesActual, mesActual, boxstate.horasuso, boxstate.facturado);
    // }, [openModal]);

    const onIniciar = (
        ejercicio_inicio,
        ejercicio_fin,
        periodo_inicio,
        periodo_fin,
        estatus,
        motivo,
        filtroSucursales,
        filtoAdr
    ) => {
        setLoader({ ...loader, mostrar: true });
        var sucursalesEnviar = filtroSucursales;
        var adrEnviar = filtoAdr;

        var p_fin = "";
        if (filtroSucursales === undefined || filtroSucursales === null || filtroSucursales === "") {
            sucursalesEnviar = "0";
        }
        if (filtoAdr === undefined || filtoAdr === null || filtoAdr === "") {
            adrEnviar = "0";
        }
        if (
            periodo_fin === undefined ||
            periodo_fin === null ||
            periodo_fin === "" ||
            periodo_fin === "0"
        ) {
            p_fin = periodo_inicio;
        } else {
            p_fin = periodo_fin;
        }

        if (Number(p_fin) < Number(periodo_inicio) && Number(ejercicio_fin) < Number(ejercicio_inicio)) {
            Swal.fire(
                "DASHBOARD",
                "La fecha de inicio no puede ser menor a la final",
                "warning"
            );
            return;
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardPostventa/ServiciosPendientes?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&adr=${adrEnviar}&sucursal=${sucursalesEnviar}&hrsuso=${boxstate.horasuso}&msj_estatus=${estatus}&motivo=${motivo}&facturado=${boxstate.facturado}`
                )
                .then((result) => {

                    setLoader({ ...loader, mostrar: false });
                    setServiciosPendientes(result);

                    const mesInicio = meses[periodo_inicio - 1];
                    const mesFin = meses[p_fin - 1];

                    let tituloP = "SERVICIOS PENDIENTES ";

                    // 1️⃣ Mes diferente y ejercicio diferente
                    if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
                        tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
                    }
                    // 2️⃣ Mismo mes y ejercicio diferente
                    else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
                        tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
                    }
                    // 3️⃣ Mes diferente y mismo ejercicio
                    else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
                        tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
                    }
                    // 4️⃣ Mismo mes y mismo ejercicio
                    else {
                        tituloP += `${mesInicio} - ${ejercicio_inicio}`;
                    }

                    setTitulo(tituloP);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    }

    const onExecute = (
        ejercicio_inicio,
        ejercicio_fin,
        periodo_inicio,
        periodo_fin
    ) => {
        // console.log(horasuso)
        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var p_fin = "";
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (
            periodo_fin === undefined ||
            periodo_fin === null ||
            periodo_fin === "" ||
            periodo_fin === "0"
        ) {
            p_fin = periodo_inicio;
        } else {
            p_fin = periodo_fin;
        }

        if (Number(periodo_fin) < Number(periodo_inicio) && Number(ejercicio_fin) <= Number(ejercicio_inicio)) {
            Swal.fire(
                "DASHBOARD",
                "La fecha de inicio no puede ser menor a la final",
                "warning"
            );
            setLoader({ ...loader, mostrar: false });
            return;

        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardPostventa/ServiciosPendientes?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&adr=${adr}&sucursal=${sucursales}&hrsuso=${boxstate.horasuso}&msj_estatus=${boxstate.estatus}&motivo=${boxstate.motivo}&facturado=${boxstate.facturado}`
                )
                .then((result) => {

                    setLoader({ ...loader, mostrar: false });
                    setServiciosPendientes(result);

                    const mesInicio = meses[periodo_inicio - 1];
                    const mesFin = meses[p_fin - 1];

                    let tituloP = "SERVICIOS PENDIENTES ";

                    // 1️⃣ Mes diferente y ejercicio diferente
                    if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
                        tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
                    }
                    // 2️⃣ Mismo mes y ejercicio diferente
                    else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
                        tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
                    }
                    // 3️⃣ Mes diferente y mismo ejercicio
                    else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
                        tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
                    }
                    // 4️⃣ Mismo mes y mismo ejercicio
                    else {
                        tituloP += `${mesInicio} - ${ejercicio_inicio}`;
                    }

                    setTitulo(tituloP);
                    limpiarFiltros();
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    // console.log(serviciosPendientes)

    // Mapa de títulos de grupo
    const gruposTitulos = {
        100: "100 horas",
        475: "475 horas",
        850: "850 horas",
        1225: "1225 horas",
        1600: "1600 horas",
        1975: "1975 horas",
    };

    // Función para agrupar y ordenar los grupos según el orden deseado
    const agruparPorGrupo = (data) => {
        if (!data) return [];

        // Agrupar por grupo
        const gruposMap = data.reduce((acc, item) => {
            if (!acc[item.grupo]) acc[item.grupo] = [];
            acc[item.grupo].push(item);
            return acc;
        }, {});

        const orden = [100, 475, 850, 1225, 1600, 1975];

        return orden
            .filter((g) => gruposMap[g])
            .map((g) => ({
                grupo: gruposTitulos[g],
                registros: gruposMap[g],
            }));
    };

    const handleOpenModalComentarios = (folio, fecha) => {
        setFolioSelected(folio);
        setFechaRecordatorio(fecha)
        setOpenModalComentarios(true);
    };

    const handleCloseModalComentarios = () => {
        setOpenModalComentarios(false);
        // if (actualizarLista) actualizarLista();
    };

    const calcularTotalesGrupo = (registros) => {
        return {
            totalRegistros: registros.length,
            totalFacturados: registros.filter(r => r.facturado === "S").length,
            totalMensajes: registros.reduce(
                (acc, r) => acc + (Number(r.mensajes_enviados) || 0),
                0
            ),
            totalMonto: registros.reduce(
                (acc, r) => acc + (Number(r.monto_facturado) || 0),
                0
            ),
        };
    };


    return (
        <PlantillaScreen
            titulo={titulo}
            className={"servicios-pendientes-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />
            <div className="servicios-pendientes-actions">
                <div
                    className="servicios-pendientes-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="servicios-pendientes-actions-filtro">
                    <FiltroPostventaCotizaciones
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        dashboard={true}
                        mostrarhoras={true}
                        mostrarestadobasico={true}
                        mostrarmotivoServicios={true}
                        mostrarfacturado={true}
                        ejercicio_inicio={ejercicio_inicio}
                        ejercicio_fin={ejercicio_fin}
                        periodo_inicio={periodo_inicio}
                        periodo_fin={periodo_fin}
                        sucursalesEncontrados={sucursales}
                        adrEncontrados={adr}
                        estatusEncontrado={estatus}
                        motivoEncontrado={motivo}
                        filtroSucursales={filtroSucursales}
                    />
                </div>
                <div className="buttons">
                    <button
                        className="servicios-pendientes-header-configuracion"
                        onClick={() => onConfiguracionPaquetes()}
                    >
                        <Settings /> Configuración de paquetes
                    </button>

                    <button
                        className="servicios-pendientes-header-excluir"
                        onClick={() => handleOpenModalExcluir()}
                    >
                        <DoNotDisturbIcon /> Reglas de Exclusión
                    </button>
                </div>
            </div>
            <div className="servicios-pendientes-header-info">
                <div></div>
                {/* <div className="servicios-pendientes-info-filtro">
                    <div className="servicios-pendientes-info-filtro-titulo">
                        {boxstate.pv.sucursal.length === 0
                            ? "Region: "
                            : "Sucursal:"
                        }
                    </div>
                    <div className="servicios-pendientes-info-filtro-parametros">
                        {boxstate.pv.sucursal.length === 0
                            ? boxstate.pv.adr.map(s => capitalizePalabras(s.adr)).join(', ')
                            : boxstate.pv.sucursal.map(s => capitalizePalabras(s.sucursal)).join(', ')
                        }
                    </div>
                </div> */}

                {/* <div className="dash-filtro-servicio-container">
                    {filtros.estatus !== "" && (
                        <div className="dash-filtro-cotizaciones-estatus">
                            <div className="dash-filtro-cotizaciones-titulo">
                                Estatus:
                            </div>
                            <div className="dash-filtro-cotizaciones-parametros">
                                {
                                    options.estatus.find(opt => opt.value === filtros.estatus)?.label || "Todos"
                                }
                            </div>
                        </div>
                    )}
                    {filtros.mensajes !== "" && (
                        <div className="dash-filtro-cotizaciones-mensajes">
                            <div className="dash-filtro-cotizaciones-titulo">
                                Mensajes:
                            </div>
                            <div className="dash-filtro-cotizaciones-parametros">
                                {
                                    options.mensajes.find(opt => opt.value === Number(filtros.mensajes))?.label || "Todos"
                                }
                            </div>
                        </div>
                    )}
                    {filtros.facturado !== "" && (
                        <div className="dash-filtro-cotizaciones-mensajes">
                            <div className="dash-filtro-cotizaciones-titulo">
                                facturado:
                            </div>
                            <div className="dash-filtro-cotizaciones-parametros">
                                {options.facturado.find(opt => opt.value === filtros.facturado)?.label || "Todos"}
                            </div>
                        </div>
                    )}

                </div> */}

                <div className="contador-servicios-pendientes-encontrados">
                    Servicios pendientes encontrados: {datosFiltrados?.length}
                </div>
            </div>
            {serviciosPendientes && serviciosPendientes.length > 0 && (
                <div className="servicios-pendientes">
                    <div className="servicios-pendientes-container scroll">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                {/* <tr>
                                    <th colSpan={4}>Alertas de Fin de Garantia</th>
                                </tr> */}
                                <tr>
                                    {/* <th ></th> */}
                                    <th className="sticky-chat-whatsapp"></th>
                                    <th className="sticky-folio"><div>Sucursal</div></th>
                                    <th className="sticky-cliente">
                                        <div>Cliente</div>
                                    </th>
                                    <th >
                                        <div>Responsable</div>
                                    </th>
                                    <th>
                                        <div>Serie</div>
                                    </th>
                                    <th>
                                        <div>Modelo</div>
                                    </th>
                                    <th>
                                        <div>Fecha de vigencia</div>
                                    </th>
                                    {/* <th>
                                        <div>Fecha de entrega</div>
                                    </th> */}
                                    <th>
                                        <div>Fecha de envio</div>
                                    </th>
                                    <th>
                                        <FiltroMultiple
                                            label="Contacto"
                                            field="contacto"
                                            options={options.contacto}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}

                                        />
                                    </th>

                                    <th>
                                        <FiltroMultiple
                                            label="Estatus"
                                            field="estatus"
                                            options={options.estatus}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />
                                    </th>
                                    <th>
                                        <FiltroMultiple
                                            label="Mensaje"
                                            field="mensajes"
                                            options={options.mensajes}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                            transformValue={Number}
                                        />
                                    </th>
                                    {/* <th>
                                        <div>Motivo</div>
                                    </th> */}
                                    <th>
                                        <FiltroMultiple
                                            label="Facturado"
                                            field="facturado"
                                            options={options.facturado}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />
                                    </th>
                                    <th>
                                        <div>Importe</div>
                                    </th>
                                    <th>
                                        <div>Comentarios</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                {agruparPorGrupo(datosFiltrados).map((grupo, i) => {
                                    const totales = calcularTotalesGrupo(grupo.registros);

                                    return (
                                        <React.Fragment key={i}>
                                            <tr className="grupo-row">
                                                <td colSpan={14} className="grupo-header">
                                                    {grupo.grupo}
                                                </td>
                                            </tr>

                                            {/* Filas de los registros */}
                                            {grupo.registros.map((item, index) => (
                                                <tr >
                                                    <td className="sticky-chat-whatsapp">
                                                        <div
                                                            className={
                                                                esTelefonoValido(item.contacto)
                                                                    ? "boton-chat-whatsapp"
                                                                    : "boton-chat-whatsapp-sin-numero"
                                                            }
                                                            // onClick={() => onGeneraPDF(co.folio)}
                                                            onClick={
                                                                esTelefonoValido(item.contacto)
                                                                    ? () =>
                                                                        handleOpenModalChat(item.contacto, item.cliente)
                                                                    : undefined

                                                            }
                                                        >
                                                            <WhatsAppIcon />
                                                        </div>
                                                    </td>
                                                    <td className="sticky-folio celda-sucusal" onClick={() => handleOpenModalSucursal(item.id_registro)}>{capitalizePalabras(item.sucursal)}</td>
                                                    <td className="sticky-cliente celda-cliente">{capitalizePalabras(item.cliente)}</td>
                                                    <td className="celda-cliente">{capitalizePalabras(item.responsable)}</td>
                                                    <td className="ta-center">{item.num_serie}</td>
                                                    <td>{item.modelo}</td>
                                                    <td className="ta-center">{item.fecha_vigencia}</td>
                                                    {/* <td className="ta-center">{item.entregado}</td> */}
                                                    <td className="ta-center">{item.fecha_envio}</td>
                                                    <td className="celda-whatsapp ta-center">
                                                        <div className="whatsapp">
                                                            {item.contacto === "N" ? (
                                                                <div
                                                                    className="boton-agregar-contacto"
                                                                    onClick={() => handleOpenModal(item.id_registro)}
                                                                >
                                                                    <AddCircleOutlineIcon /> Agregar
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className={
                                                                        esTelefonoValido(item.contacto)
                                                                            ? "editar-numero"
                                                                            : "editar-numero-error"
                                                                    }
                                                                // className="editar-numero"
                                                                >
                                                                    {item.contacto}
                                                                    <span
                                                                        onClick={() =>
                                                                            handleOpenModal(
                                                                                item.id_registro
                                                                            )
                                                                        }
                                                                    >
                                                                        <EditIcon />
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="celda-estatus">
                                                        {item.estado.startsWith("RL") && (
                                                            <>Respuesta escrita{item.estado.substring(2).trim()}</>
                                                        )}
                                                        {item.estado === "PE" && 'Pendiente de envio'}
                                                        {item.estado === "EN" && 'Mensaje enviado'}
                                                        {item.estado === "EG" && 'Mensaje entregado'}
                                                        {item.estado === "LE" && 'Mensaje leído'}
                                                        {item.estado === "ET" && 'Error en número de teléfono'}
                                                        {item.estado === "CI" && 'Cliente con interes'}
                                                        {item.estado === "SI" && 'Cliente sin interes'}
                                                        {item.estado === "EE" && 'Error en el envio'}
                                                    </td>

                                                    <td className="ta-center">
                                                        {/* {item.mensaje_enviado === "S" ? (
                                                        <CheckCircleIcon
                                                            sx={{ color: "#5aa05b !important" }}
                                                        />
                                                    ) : (
                                                        <RemoveCircleIcon
                                                            sx={{ color: "#7b7b7b !important" }}
                                                        />
                                                    )} */}
                                                        {item.mensajes_enviados}
                                                    </td>

                                                    {/* <td className="ta-center">
                                                    {item.motivo === "PS" && 'Precio del servicio'}
                                                    {item.motivo === "DC" && 'Crédito Disponible'}
                                                    {item.motivo === "AB" && 'Atención brindada'}
                                                    {item.motivo === "NN" && 'No se necesitó'}
                                                </td> */}
                                                    <td className="ta-center">
                                                        {item.facturado === "S" ? (
                                                            <CheckCircleIcon
                                                                sx={{ color: "#5aa05b !important" }}
                                                            />
                                                        ) : (
                                                            <RemoveCircleIcon
                                                                sx={{ color: "#7b7b7b !important" }}
                                                            />
                                                        )}
                                                    </td>
                                                    <td className="ta-center">
                                                        {FormatMoney(item.monto_facturado, 2)}
                                                    </td>
                                                    <td className="celda-comentario">
                                                        <div className="contenido-flex">
                                                            <div
                                                                // className={`boton-detalle-cotizaciones ${puedeEditar ? "" : "inhabilitado"}`}
                                                                onClick={() => handleOpenModalComentarios(item.id_registro)}
                                                            >
                                                                <CommentIcon />
                                                            </div>
                                                            <span className="comentario-texto">
                                                                <label>{item.comentario}</label>
                                                                <br />
                                                                {item.creador_comentario && (
                                                                    <span>
                                                                        Creado por:
                                                                        {item.creador_comentario} - el{" "}
                                                                        {item.fecha_comentario}
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                            {/* 🔹 FILA TOTAL DEL GRUPO */}
                                            <tr className="tfoot">
                                                <td colSpan={8} className="ta-right fw-bold">
                                                    Registros:
                                                    {/* {grupo.grupo} */}
                                                </td>

                                                <td className="ta-center fw-bold">
                                                    {totales.totalRegistros}
                                                </td>

                                                <td colSpan={2}></td>

                                                <td className="ta-right fw-bold">
                                                    Monto total:
                                                </td>
                                                <td className="ta-center fw-bold">
                                                    {totales.totalMonto}
                                                </td>


                                                <td colSpan={2}></td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>

                        </table>
                    </div>
                </div>
            )}
            <ModelosExcluidosMantenimientoModal
                open={openModalExcluir}
                onClose={handleCloseModalExcluir}
            />
            <AgregarContactoModal
                open={openModal}
                onClose={handleCloseModal}
                idRegistro={registroSelect}
            />
            <CambiarSucursalModal
                open={openModalSucursal}
                onClose={handleCloseModalSucursal}
                idRegistro={registroSelect}
            />
            <ModalComentariosTimeline
                open={openModalComentarios}
                onClose={handleCloseModalComentarios}
                folio={folioSelected}
                tipo={"SE"}
                update={onUpdate}
            />
            <ChatScreen
                open={modalChat}
                onClose={handleCloseModalChat}
                numeroTelefono={telefonoContacto}
                cliente={cliente}
                modulo={"POSVENTA"}
            />
        </PlantillaScreen>
    )
}
